import { render, staticRenderFns } from "./ViewRideDetails.vue?vue&type=template&id=382f8d9e&scoped=true&lang=pug&"
import script from "./ViewRideDetails.vue?vue&type=script&lang=js&"
export * from "./ViewRideDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewRideDetails.vue?vue&type=style&index=0&id=382f8d9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f8d9e",
  null
  
)

export default component.exports